@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';
@import (reference) 'ui-components/components/text/text.module.less';
@import (reference) 'ui-components/components/responsive-layout/styles.module.less';

@signInAndSecurityPageWrapperClass: signInAndSecurity;

.@{signInAndSecurityPageWrapperClass} {
  // style was removed, but this class is used by some :has targeting in sso-account-management.less, so keeping for now
}

.form {
  gap: @space-16;
  justify-content: space-evenly;

  padding-bottom: @space-16;
  border-bottom: solid 1px var(--gray-DFE4E8);
}

.form-checkbox {
  .paragraph(); // from text.less
  height: auto;
  padding: 5px 0;
}

.submit-button {
  width: fit-content;
}

.input {
  width: 50%;
}

@media @small-media-query {
  .input {
    width: 70%;
  }
}

@media @extra-small-media-query {
  .input {
    width: 90%;
  }
}
